import { MAX_NEST_INIT_TRY_COUNT } from "@/consts";
import { sentryCaptureException } from "./sentry";

export function nestInitialize(count = 0) {
  return new Promise((resolve) => {
    try {
      nest.init();
      resolve(true);
    } catch (error) {
      if (count >= MAX_NEST_INIT_TRY_COUNT) {
        sentryCaptureException(error, {
          tags: { function: "nestInitialize" },
          context: {
            count: count.toString(),
          },
        });

        resolve(true);
        return;
      }

      setTimeout(() => {
        nestInitialize(count + 1);
      }, 100);
    }
  });
}

export function validateSession() {
  return new Promise((resolve) => {
    nest.validateSession({
      success: (response) => {
        if (response.userId) {
          resolve(true);
          return;
        }

        resolve(false);
      },
      failure: () => {
        resolve(false);
      },
    });
  });
}

export function getParentAgreementToken(state: string) {
  return new Promise((resolve: (token: string) => void, reject) => {
    nest.getParentAgreementToken({
      state,
      success: (response) => {
        resolve(response.token);
      },
      failure: (error) => {
        reject(error);
      },
    });
  });
}

export function getCancelWithdrawalToken(state: string) {
  return new Promise((resolve: (token: string) => void, reject) => {
    nest.getCancelWithdrawalToken({
      state,
      success: (response) => {
        resolve(response.token);
      },
      failure: (error) => {
        reject(error);
      },
    });
  });
}

export function getUnprotectToken(state: string) {
  return new Promise((resolve: (token: string) => void, reject) => {
    nest.getUnprotectToken({
      state,
      success: (response) => {
        resolve(response.token);
      },
      failure: (error) => {
        reject(error);
      },
    });
  });
}
